import React from 'react';
import DataGridShell from './DataGridShell';

const money = (p) => p?.value != null ? Number(p.value).toFixed(2) : '0.00';

const columns = [
    { field: 'tenant_store_name', headerName: 'Tenant Name', width: 150 },
    { field: 'tenant_group_name', headerName: 'Group Name', width: 200 },
    { field: 'tenant_code', headerName: 'Tenant Code', width: 150 },
    { field: 'tenant_unit_code', headerName: 'Unit Code', width: 150 },
    { field: 'tenant_status', headerName: 'Status', width: 130 },
    { field: 'property_name', headerName: 'Property', width: 150 },
    { field: 'subcategory_name', headerName: 'Subcategory', width: 200 },
    { field: 'floor', headerName: 'Floor', width: 100 },
    { field: 'transaction_date', headerName: 'Date', width: 130 },
    { field: 'invoice_no', headerName: 'Invoice No', width: 150 },
    { field: 'transaction_time', headerName: 'Time', width: 130 },
    { field: 'currency', headerName: 'Cur', width: 80 },
    { field: 'sku', headerName: 'SKU', width: 150 },
    { field: 'item_name', headerName: 'Item Name', width: 240 },
    { field: 'quantity', headerName: 'Qty', width: 90, type: 'number', cellClass: 'ag-right-aligned-cell' },
    { field: 'unit_price', headerName: 'Unit Price', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'total_price', headerName: 'Total Price', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'netsale_without_vat', headerName: 'Net Sale (No VAT)', width: 160, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'discount', headerName: 'Discount', width: 120, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'product_category1', headerName: 'Category 1', width: 160 },
    { field: 'product_category2', headerName: 'Category 2', width: 160 },
    { field: 'product_category3', headerName: 'Category 3', width: 160 }
];

const kpiAccumulators = [
    { field: 'total_price', label: 'Σ Total Price', money: true },
    { field: 'netsale_without_vat', label: 'Σ Net Sale', money: true },
    { field: 'quantity', label: 'Σ Qty', money: false }
];

const DataGridItemWiseView = () => (
    <DataGridShell
        mode="item"
        endpoint="/datagrid/getdatagriditemwise"
        exportEndpoint="/datagriditemexport/export-csv"
        columns={columns}
        kpiAccumulators={kpiAccumulators}
    />
);

export default DataGridItemWiseView;
